<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 584 570"
    fill="white"
    :width="widthAttr"
    :height="heightAttr"
    overflow="visible"
  >
    <g filter="url(#filter0_dd_1113_2)">
      <path
        d="M577 23C577 14.7157 570.284 8 562 8H444.124C438.785 8 433.847 10.8387 431.161 15.4535L399.089 70.5466C396.403 75.1613 391.465 78 386.126 78H294H152.5H26C17.7157 78 11 84.7157 11 93V545C11 553.284 17.7158 560 26 560H562C570.284 560 577 553.284 577 545V23Z"
        class="fill-current-color"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1113_2"
        x="0"
        y="0"
        width="584"
        height="570"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1113_2" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="1" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1113_2" result="effect2_dropShadow_1113_2" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1113_2" result="shape" />
      </filter>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'LoginComponent',

    props: {
      width: {
        type: String,
        required: false,
      },

      height: {
        type: String,
        required: false,
      },

      size: {
        type: String,
        required: false,
      },
    },

    computed: {
      widthAttr() {
        if (this.height) return undefined;
        if (this.size) return this.size;
        return this.width || '75vh';
      },

      heightAttr() {
        if (this.width) return undefined;
        if (this.size) return this.size;
        return this.height || '73vh';
      },
    },
  };
</script>
